import React from "react";
import { Slide } from "@material-ui/core";
import { ANIMATION_DIRECTION } from "@icarius-utils/constants";

const DialogTransition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction={ANIMATION_DIRECTION} ref={ref} {...props} />;
});

export default DialogTransition;